var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteInfoLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 73,
    viewBox: "0 0 119 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M85 41.4039V54.1539C85 66.9039 79.9 72.0039 67.15 72.0039H51.85C39.1 72.0039 34 66.9039 34 54.1539V38.8539C34 26.1039 39.1 21.0039 51.85 21.0039H64.6",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M85.0055 41.4039H74.8055C67.1555 41.4039 64.6055 38.8539 64.6055 31.2039V21.0039L85.0055 41.4039Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M46.75 49.0508H62.05",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M46.75 59.2539H56.95",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1 61.6706L4.25 65.0039L14 55.0039",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M113.621 33.9432L107.818 39.7456C107.589 39.9751 107.376 40.4012 107.326 40.7127L107.015 42.9254C106.9 43.7286 107.458 44.2859 108.261 44.1711L110.473 43.8597C110.785 43.8105 111.227 43.5975 111.441 43.368L117.243 37.5656C118.243 36.5658 118.718 35.4019 117.243 33.9267C115.784 32.4679 114.62 32.9433 113.621 33.9432Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M112.781 34.7773C113.273 36.5476 114.65 37.9244 116.42 38.4161",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.6208 5.64496L21.7238 12.7515C21.886 13.0326 22.2425 13.3487 22.5306 13.4768L24.5873 14.3503C25.3334 14.669 26.016 14.2749 26.113 13.4694L26.3849 11.2515C26.418 10.9379 26.3268 10.4553 26.1602 10.19L22.0573 3.0836C21.3503 1.85904 20.3492 1.09868 18.5425 2.14179C16.7558 3.17332 16.9138 4.4204 17.6208 5.64496Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.2109 6.67188C20.0481 6.65507 21.7343 5.68153 22.6675 4.09888",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteInfoLogo);
export default __webpack_public_path__ + "static/media/complete_info_logo.a61580223d29f57ce50e2d14fdc0de86.svg";
export { ForwardRef as ReactComponent };